import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IBandhaiReceipt,
  IBandhaiReceiptInitialState,
} from "./bandhaiReceiptModel";
import {
  createBandhaiReceipt,
  deleteBandhaiReceipt,
  findAllBandhaiReceipt,
  findByOrderNoBandhaiReceipt,
  getAllOrderBandhaiIssue,
  getBandhaiReceiptById,
  updateBandhaiReceipt,
} from "./services/bandhaiReceipt.services";

const initialState: IBandhaiReceiptInitialState = {
  loading: false,
  error: "",
  BandhaiIssueOrderList: [],
  BandhaiReceiptID: null,
  BandhaiReceiptList: [],
  BandhaiReceiptDetail: {
    karigar_id: null,
    receipt_date: new Date(),
    bandhai_receipt_order: [],
    karigar_name: "",
  },
  FilterBandhaiReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
  BandhaiReceiptOrderItemIndex: -1,
  BandhaiReceiptApprovalItemIndex: -1,
  BandhaiReceiptApprovalItemDeleteConfirmDialog: false,
  BandhaiReceiptUsedByKarigarItemIndex: -1,
  BandhaiReceiptKarigarItemDeleteConfirmDialog: false,
  BandhaiReceiptChargesDetailIndex: -1,
  BandhaiReceiptChargesDetailDeleteConfirmDialog: false,
  BandhaiReceiptOrderSelectItemDialog: false,
  BandhaiReceiptOrderSave: false,
  BandhaiReceiptViewImageDialog: false,
  BandhaiReceiptPreviousOrder: null,
  BandhaiReceiptChecklistDialog: null,
};

const bandhaiReceiptSlice = createSlice({
  name: "bandhaireceipt",
  initialState,
  reducers: {
    clearBandhaiReceiptDetail: (state) => {
      state.BandhaiReceiptDetail = initialState.BandhaiReceiptDetail;
    },
    setBandhaiReceiptID: (state, action) => {
      state.BandhaiReceiptID = action.payload;
    },
    setFilterBandhaiReceipt: (state, action) => {
      state.FilterBandhaiReceipt = action.payload;
    },
    setBandhaiReceiptOrderSave: (state, action) => {
      state.BandhaiReceiptOrderSave = action.payload;
    },
    clearFilterBandhaiReceipt: (state) => {
      state.FilterBandhaiReceipt = initialState.FilterBandhaiReceipt;
    },

    setBandhaiReceiptPreviousOrder: (state, action) => {
      state.BandhaiReceiptPreviousOrder = action.payload;
    },
    setBandhaiReceiptOrderItemIndex: (state, action) => {
      state.BandhaiReceiptOrderItemIndex = action.payload;
    },
    setBandhaiReceiptApprovalItemIndex: (state, action) => {
      state.BandhaiReceiptApprovalItemIndex = action.payload;
    },
    setBandhaiReceiptUsedByKarigarItemIndex: (state, action) => {
      state.BandhaiReceiptUsedByKarigarItemIndex = action.payload;
    },

    setBandhaiReceiptChargesDetailIndex: (state, action) => {
      state.BandhaiReceiptChargesDetailIndex = action.payload;
    },
    openBandhaiReceiptChargesDetailDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptChargesDetailDeleteConfirmDialog = true;
    },
    closeBandhaiReceiptChargesDetailDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptChargesDetailDeleteConfirmDialog = false;
    },

    openBandhaiReceiptApprovalItemDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptApprovalItemDeleteConfirmDialog = true;
    },
    closeBandhaiReceiptApprovalItemDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptApprovalItemDeleteConfirmDialog = false;
    },
    openBandhaiReceiptKarigarItemDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptKarigarItemDeleteConfirmDialog = true;
    },
    closeBandhaiReceiptKarigarItemDeleteConfirmDialog: (state) => {
      state.BandhaiReceiptKarigarItemDeleteConfirmDialog = false;
    },
    openBandhaiReceiptOrderSelectItemDialog: (state) => {
      state.BandhaiReceiptOrderSelectItemDialog = true;
    },
    closeBandhaiReceiptOrderSelectItemDialog: (state) => {
      state.BandhaiReceiptOrderSelectItemDialog = false;
    },

    openBandhaiReceiptChecklistDialog: (state) => {
      state.BandhaiReceiptChecklistDialog = true;
    },
    closeBandhaiReceiptChecklistDialog: (state) => {
      state.BandhaiReceiptChecklistDialog = false;
    },
    openBandhaiReceiptViewImageDialog: (state) => {
      state.BandhaiReceiptViewImageDialog = true;
    },
    closeBandhaiReceiptViewImageDialog: (state) => {
      state.BandhaiReceiptViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllBandhaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllBandhaiReceipt.fulfilled,
      (state, action: PayloadAction<IBandhaiReceipt[]>) => {
        state.loading = false;
        state.BandhaiReceiptList = action.payload || [];
      },
    );
    builder.addCase(findAllBandhaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BandhaiReceiptList = [];
    });

    builder.addCase(createBandhaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createBandhaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createBandhaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateBandhaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateBandhaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBandhaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteBandhaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBandhaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBandhaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBandhaiReceiptById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBandhaiReceiptById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BandhaiReceiptDetail = action.payload;
    });
    builder.addCase(getBandhaiReceiptById.rejected, (state, action) => {
      state.loading = false;
      state.BandhaiReceiptDetail = initialState.BandhaiReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(findByOrderNoBandhaiReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByOrderNoBandhaiReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(findByOrderNoBandhaiReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllOrderBandhaiIssue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllOrderBandhaiIssue.fulfilled, (state, action) => {
      state.loading = false;
      state.BandhaiIssueOrderList = action.payload || [];
    });
    builder.addCase(getAllOrderBandhaiIssue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BandhaiIssueOrderList = initialState.BandhaiIssueOrderList;
    });
  },
});

export const {
  clearBandhaiReceiptDetail,
  clearFilterBandhaiReceipt,
  closeBandhaiReceiptApprovalItemDeleteConfirmDialog,
  closeBandhaiReceiptKarigarItemDeleteConfirmDialog,
  closeBandhaiReceiptOrderSelectItemDialog,
  openBandhaiReceiptApprovalItemDeleteConfirmDialog,
  openBandhaiReceiptKarigarItemDeleteConfirmDialog,
  openBandhaiReceiptOrderSelectItemDialog,
  setBandhaiReceiptApprovalItemIndex,
  setBandhaiReceiptID,
  setBandhaiReceiptOrderItemIndex,
  setBandhaiReceiptUsedByKarigarItemIndex,
  setFilterBandhaiReceipt,
  setBandhaiReceiptOrderSave,
  setBandhaiReceiptPreviousOrder,
  openBandhaiReceiptChecklistDialog,
  closeBandhaiReceiptChecklistDialog,
  openBandhaiReceiptViewImageDialog,
  closeBandhaiReceiptViewImageDialog,
  openBandhaiReceiptChargesDetailDeleteConfirmDialog,
  closeBandhaiReceiptChargesDetailDeleteConfirmDialog,
  setBandhaiReceiptChargesDetailIndex,
} = bandhaiReceiptSlice.actions;
export default bandhaiReceiptSlice.reducer;
